import axios from 'axios';

const RESOURCE_NAME = '/enterprise';

export default {

    getPermissionHolders() {
        return axios.get(`${RESOURCE_NAME}/get-permission-holders`)
    },

    getProfileInfo() {
        return axios.get(`${RESOURCE_NAME}/get-profile-info`)
    },

    saveProfileInfo(data) {
        return axios.post(`${RESOURCE_NAME}/save-profile-info`, data)
    },

    getEmailTemplates() {
        return axios.get(`${RESOURCE_NAME}/get-email-templates`)
    },

    getEmailTemplateEdit(type) {
        return axios.get(`${RESOURCE_NAME}/get-email-template-edit?type=${type}`)
    },

    saveEmailTemplate(type, data) {
        return axios.post(`${RESOURCE_NAME}/save-email-template?type=${type}`, data)
    },
}